'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import replacePlaceholders from 'labels/lib/replacePlaceholders'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { OrderLine } from 'my-purchases/components/PurchaseCard/components/OrderLine/OrderLine'
import type { Order } from 'my-purchases/types/purchaseList'
import { getStatus } from 'my-purchases/utils/getStatus'
import { ClientLink } from 'utils/link/client'

import styles from 'my-purchases/components/PurchaseCard/components/CarouselHeader/CarouselHeader.module.scss'

interface SimpleHeaderPropos {
	readonly order: Order
	readonly link: string
	readonly dataTestId: string
	readonly isActive: boolean
	readonly onClick: () => void
}
export function SimpleHeader({
	link,
	order,
	isActive,
	dataTestId,
	onClick,
}: SimpleHeaderPropos) {
	const { t } = useLabels()
	const {
		country: { locale },
	} = useMasterData()

	const { id, lines } = order

	const { title, subtitle, alert, placeholders } = getStatus({
		order,
		locale,
		isActive,
	})

	const descriptionLabel = placeholders
		? replacePlaceholders(t(alert ?? subtitle), placeholders)
		: t(alert ?? subtitle)

	return (
		<ClientLink
			href={link}
			className={styles.link}
			onClick={onClick}
			data-testid={dataTestId}
			linkProps={{
				'aria-label': replacePlaceholders(
					t('accessibility.myPurchases.orderCard.simple.text'),
					{
						1: id,
						2: `${t(title)}, ${descriptionLabel}`,
						3: lines?.length ?? 0,
					}
				),
			}}
		>
			<OrderLine
				status={title}
				description={subtitle}
				alert={alert}
				placeholders={placeholders}
				dataTestId={dataTestId}
			/>
		</ClientLink>
	)
}
